import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "../../Localization.jsx"

import LocaleDetailView from "../../views/locale/LocaleDetailView.jsx"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  Button,
} from '@material-ui/core';

class EditLocaleDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      activeTab: 0,
    };
    autoBind(this);
  }

  changeTab(index) {
    let newIndex = this.state.activeTab;
    if (this.refs.localeDetailView) {
      if (this.refs.localeDetailView.validateInput()) {
        newIndex = index;
      }
    }
    else {
      newIndex = index;
    }
    this.setState({ activeTab: newIndex });
    this.state.activeTab = newIndex;

    if (this.refs.localeDetailView) {
      this.refs.localeDetailView.changeActiveView(newIndex);
    }
  }

  handleTabChange = (event, index) => {
    this.changeTab(index);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    this.close();
  }

  closeCancelClicked() {

  }

  closeConfirmClicked() {
    this.close();
  }

  handleCancel() {
    this.handleClose();
  }

  handleUpdateClicked() {
    let localeDetailViewState = this.refs.localeDetailView.state;
    if (this.refs.localeDetailView.validateInput()) {
      let requestObj = {
        locale_name: localeDetailViewState.localeName.trim(),
        description: localeDetailViewState.localeDesc.trim(),
        is_ready: (localeDetailViewState.localePublish? 1 : 0),
        is_share: (localeDetailViewState.localeShareable? 1 : 0),
        is_manual_play: (localeDetailViewState.localeManualPlay? 1 : 0),
        tn_file_id: localeDetailViewState.localeCoverFileID,
        intro_file_id: localeDetailViewState.localeCoverFileID,
        kla: localeDetailViewState.localeKLA,
        subject: localeDetailViewState.localeSubject,
        color: 0,
        lang: "tc",
        user_id: this.props.root.getMyUserId(),
        school_id: this.props.root.getMySchoolId(),
        id: this.props.localeData.id,
      };
      this.props.root.refs.API.request("update_locale", requestObj, this.updateLocaleOK, this.updateLocaleFailed);
    }
  }

  updateLocaleOK(res) {
    this.props.parent.refreshLocaleList();
    this.props.root.addNotification(Localization.strings.UPDATED);
  }

  updateLocaleFailed() {
    console.log("update locale failed");
    this.props.root.addNotification(Localization.strings.UPDATE_FAILED);
  }

  onUploadSuccess() {
    this.handleUpdateClicked();
  }

  render() {
    const steps = this.props.parent.getSteps();

    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'md'}
          onClose={this.handleClose}
        >
          <DialogTitle>
            {Localization.strings.EDIT + " - " + this.props.localeData.locale_name}
          </DialogTitle>

          <DialogContent>
            <Tabs
              value={this.state.activeTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              centered
              variant="fullWidth"
              style={{padding:'0 0 14px 0'}}
            >
              {steps.map((label, index) => {
                return (
                  <Tab key={index} label={label}/>
                );
              })}
            </Tabs>

            <LocaleDetailView root={this.props.root} parent={this} ref="localeDetailView"
              locale_name={this.props.localeData.locale_name}
              school_id={this.props.localeData.school_id}
              user_id={this.props.localeData.user_id}
              description={this.props.localeData.description}
              kla={this.props.localeData.kla}
              subject={this.props.localeData.subject}
              color={this.props.localeData.color}
              lang={this.props.localeData.lang}
              is_ready={this.props.localeData.is_ready}
              is_share={this.props.localeData.is_share}
              is_manual_play={this.props.localeData.is_manual_play}
              tn_file_id={this.props.localeData.tn_file_id}
              intro_file_id={this.props.localeData.intro_file_id}
              activeView={this.state.activeTab}
            />
          </DialogContent>

          <DialogActions style={{padding:'16px 24px'}}>
            <Button
              onClick={this.handleCancel}
            >
              {Localization.strings.CANCEL}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.handleUpdateClicked}
            >
              {Localization.strings.UPDATE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default EditLocaleDialog;
